export default __webpack_public_path__ + "static/media/discountsFavicon.de8f7c4c.png";